import { render } from "./UpcomingBirthdays.vue?vue&type=template&id=ab454afe&scoped=true"
import script from "./UpcomingBirthdays.vue?vue&type=script&lang=js"
export * from "./UpcomingBirthdays.vue?vue&type=script&lang=js"

import "./UpcomingBirthdays.vue?vue&type=style&index=0&id=ab454afe&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab454afe"]])

export default __exports__